<template>
  <div>
    <ots-main-title></ots-main-title>

    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
      @search="getTableData"
    ></ots-table-group-new>

    <ots-custom-dialog :dialog.sync="editDialog" title="编辑：考点例外设置" width="60%" class="exceptDialog">
      <template v-slot:content>
        <div class="mainForm">
          <el-form ref="form" :model="editForm">
            <h3 style="margin: 10px -15px;">基本设置</h3>
            <el-form-item label="考试方式：">
              <el-radio-group v-model="editForm.examType">
                <el-radio :label="1">机房断网</el-radio>
                <el-radio :label="2">考中断网</el-radio>
                <el-radio :label="3">公网</el-radio>
              </el-radio-group>
            </el-form-item>
            <h3 style="margin: 10px -15px;">人脸识别签到设置</h3>
            <el-form-item label="人脸识别签到：" >
              <el-switch v-model="editForm.isSignState" :active-value="1" :inactive-value="0"></el-switch>
              <span class="machineTip" v-show="editForm.examType=='100'">(机房断网模式使用OIS签到)</span>
            </el-form-item>
            <el-form-item label="人脸识别考前允许签到时间：" v-show="isShow">
              <el-select v-model="editForm.allowSignStateTimeByBefore" placeholder="请选择">
                <el-option :label="item" :value="item" v-for="item in timeList" :key="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="人脸识别考后允许签到时间：" v-show="isShow">
              <el-select v-model="editForm.allowSignStateTimeByAfter" placeholder="请选择">
                <el-option :label="item" :value="item" v-for="item in timeList" :key="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签到不通过允许人工判定：" v-show="isShow">
              <el-switch v-model="editForm.isCheckSignStateNoPass" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="签到时间已过允许签到：" v-show="isShow">
              <el-switch v-model="editForm.isSignStateOverTime" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="不刷身份证允许签到：" v-show="isShow">
              <el-switch v-model="editForm.isAllowedToSignWithoutIDCard" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="签到开启权威库核身：" v-show="isShow">
              <el-switch v-model="editForm.isSignStateByImageRecognition" :active-value="1" :inactive-value="0"></el-switch>
              <p style="display: inline-block; margin-left: 12px;" v-show="isShow && editForm.isSignStateByImageRecognition == 1">
                <el-form-item label="，每场权威库核身最多" >
                  <el-select v-model="editForm.imageRecognitionTimes">
                    <el-option label="1" :value="1"></el-option>
                    <el-option label="2" :value="2"></el-option>
                    <el-option label="3" :value="3"></el-option>
                  </el-select>
                  <span> 次</span>
                </el-form-item>
              </p>
            </el-form-item>
            
            <h3 style="margin: 10px -15px;">远程操控检测设置</h3>
            <el-form-item label="开启远程操控检测：">
              <el-switch v-model="editForm.remoteCheckFlag" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="远程操控检测频率：" v-if="editForm.remoteCheckFlag == 1">
              <span>每{{ examConfigBase.remoteCheckCycle }}秒，捕获{{ examConfigBase.remoteCatchTimes }}次</span>
            </el-form-item>
            <el-form-item label="判定后暂停作答：" v-if="editForm.remoteCheckFlag == 1">
              <el-select v-model="editForm.remoteJudgedStopAnswer">
                <el-option v-for="item in stopAnswerOptions" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span class="ml16">秒</span>
            </el-form-item>
            <el-form-item label="判定：" v-if="editForm.remoteCheckFlag == 1">
              <el-select v-model="editForm.remoteJudgedNumSubmit">
                <el-option v-for="item in judgedNumOptions" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span class="ml16">次后强制交卷</span>
            </el-form-item>

          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="editDialog = false">取消</el-button>
        <el-button round @click="editExcept" type="primary">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { 
  getPlanPlaceExamConfigAPI, 
  getPlanPlaceExamConfigByIdAPI, 
  savePlanPlaceExamConfigAPI ,
  getExamConfigBaseAPI
} from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      timeList: [60, 45, 30, 15, 0],
      stopAnswerOptions: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60],
      judgedNumOptions: [1, 2, 3, 4, 5],
      examConfigBase: {
        remoteCheckCycle: 10,
        remoteCatchTimes: 6,
      },
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '考试方式',
          type: 'select',
          requestKey: 'examType',
          label: 'name',
          value: 'id',
          data: [
            { id: -1, name: '全部' },
            { id: 1, name: '机房断网' },
            { id: 2, name: '考中断网' },
            { id: 3, name: '公网' },
          ],
        },
        {
          title: '是否需要人脸识别签到',
          type: 'select',
          requestKey: 'isSignState',
          label: 'name',
          value: 'id',
          data: [
            { id: -1, name: '全部' },
            { id: 1, name: '是' },
            { id: 0, name: '否' },
          ]
        },
      ],
      pagination: {
        total: 0,
      },
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考试类型",
          prop: "planExamType",
        },
        {
          title: "考试批次状态",
          prop: "planStateName",
        },
        {
          title: "考点名称",
          prop: "placeName",
        },
        {
          title: "考试方式",
          prop: "examMethod",
        },
        {
          title: "人脸识别签到",
          prop: "signState",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "编辑",
              click: this.editExceptInfo,
            },
          ],
        },
      ],
      requestForm: {
        planId: '',
        placeId: '',
        examType: -1,
        isSignState: -1,
        size: 10,
        page: 1,
      },
      editDialog: false,
      editForm: {
        examType: '',
        isSignState: '',
        allowSignStateTimeByBefore: '',
        allowSignStateTimeByAfter: '',
        isCheckSignStateNoPass: '',
        isSignStateOverTime: '',
        isAllowedToSignWithoutIDCard: '',
        isSignStateByImageRecognition: '',
        imageRecognitionTimes: 1,        // 权威库核身次数
        remoteCheckFlag: 1,               // 开启远程操控检测
        remoteJudgedStopAnswer: 10,       // 判定后暂停作答时长（秒）
        remoteJudgedNumSubmit: 3,         // 判定后强制交卷次数
      },
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.getTableData();
    },
  },
  computed: {
    isShow() {
      return  this.editForm.isSignState;
    }
  },
  created() {
    this.getPlan();
  },
  methods: {
    // 编辑
    async editExceptInfo(row) {
      let params = {
        planId: row.planId,
        placeId: row.placeId,
      };
      const res = await getPlanPlaceExamConfigByIdAPI(params)
      const { data: baseData } = await getExamConfigBaseAPI();
      if (baseData) {
        this.examConfigBase.remoteCheckCycle = baseData.remoteCheckCycle;
        this.examConfigBase.remoteCatchTimes = baseData.remoteCatchTimes;
      }
      // configData优先级更高，如果存在remoteCheckCycle/remoteCatchTimes则覆盖baseData的值
      if (res.data) {
        if (res.data.remoteCheckCycle != null) {
          this.examConfigBase.remoteCheckCycle = res.data.remoteCheckCycle;
        }
        if (res.data.remoteCatchTimes != null) {
          this.examConfigBase.remoteCatchTimes = res.data.remoteCatchTimes;
        }
      }
      this.editForm = res.data;
      if (this.editForm.remoteJudgedStopAnswer == null) {
        this.editForm.remoteJudgedStopAnswer = 10;
      }
      this.editDialog = true;
    },

    // 执行编辑
    async editExcept() {
      let params = { ...this.editForm }
      const { code } = await savePlanPlaceExamConfigAPI(params);
      if (code === 1) {
        this.$message.success("编辑成功！");
        this.getTableData();
      }
      this.editDialog = false;
    },

    // 获取批次
    async getPlan() {
      const { data: planData } = await getSelectPlanFn({ needAudit: 31});
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 获取考点
    async getPlace(value) {
      const { data: placeData } = await getCurrentSelectPlace({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },
    
    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm }
      const { data: tableData } = await getPlanPlaceExamConfigAPI(params);
      this.pagination.total = tableData.total;
      this.tableData = tableData.records;
    },

    changeNum(num) {
      this.requestForm.size = num;
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }

}
</script>

<style scoped lang="less">
.mainForm {
  /deep/ .el-form-item__content {
    .el-radio-group {
      padding-top: 8px;
      box-sizing: border-box;
      margin: auto;
    }
  }
  /deep/ .el-form-item__label {
    display: inline-block;
    padding: 0!important;
    width: 200px;
  }
  /deep/ .el-form-item {
    display: flex;
    align-items: center;
    height: 36px;
    line-height: 36px;
    margin-bottom: 8px;
  }  
}
.machineTip{
  color: #F56C6C;
  margin-left: 14px;
}
.noUser{ 
  user-select: none;
}
</style>